// extracted by mini-css-extract-plugin
export default {"pageRow":"PageRow_pageRow__5ggHY"};